import { render } from "./GridContainer.vue?vue&type=template&id=072679a6"
const script = {}

import "./GridContainer.vue?vue&type=style&index=0&id=072679a6&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__